module.exports = Vue;


//////////////////
// WEBPACK FOOTER
// external "Vue"
// module id = 17
// module chunks = 1